import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';

export const adminTermsFiltersSchema = z
  .object({})
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);

export type AdminTermsFilters = z.infer<typeof adminTermsFiltersSchema>;

export interface TermsVersion {
  id: string;
  version: number;
  creationDate: string;
  createdByName: string | null;
}

export interface TermsVersionDetails extends TermsVersion {
  content: string;
}
